export default __webpack_public_path__ + "static/media/2032.92611410.png";